export type TabKey = 'whole' | 'not-yet' | 'completed';

export const TAB_LIST: {
  key: TabKey;
  label: string;
  count: number;
}[] = [
  { key: 'whole', label: '전체 리뷰', count: 0 },
  { key: 'not-yet', label: '미답변', count: 0 },
  { key: 'completed', label: '답변완료', count: 0 },
];

export const DEFAULT_TAB: TabKey = 'whole';
